// src/paymentsClient.js
import { apiGet, apiPost } from "./apiClient";

// Load current user's entitlements (needs JWT)
// export async function fetchEntitlements() {
//   const res = await apiGet("/billing/me");
//   return res.data.entitlements;
// }

// Load current user's entitlements (needs JWT)
export async function fetchEntitlements() {
  try {
    const res = await apiGet("/billing/me");
    return res.data.entitlements;
  } catch (err) {
    // ✅ Guest user (not signed in): treat as no plan, no credits
    if (err?.response?.status === 401) {
      return {
        status: "inactive",
        plan: "none",
        quota_monthly: 0,
        quota_used_month: 0,
      };
    }
    throw err;
  }
}

// Start Stripe Checkout for a given plan (needs JWT)
export async function subscribe(planKey) {
  // keep your original query string format
  const res = await apiPost(
    `/billing/create-checkout-session?plan=${planKey}`,
    {} // body must exist for POST, even if empty
  );

  if (res.data?.url) {
    window.location.href = res.data.url;
  } else {
    throw new Error("No checkout URL");
  }
}

// Open Stripe customer portal (needs JWT)
export async function openBillingPortal() {
  const res = await apiPost("/billing/create-portal-session", {});

  if (res.data?.url) {
    window.location.href = res.data.url;
  } else {
    throw new Error("No portal URL");
  }
}
